/**
 * @file paddle hub 详情
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import { Breadcrumb, Button } from 'antd';
import {
    RightOutlined,
    CaretRightOutlined
} from '@ant-design/icons';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import PaddleHubDetailVersion from './components/paddle-hub-detail-version/PaddleHubDetailVersion';

import usePaddleHubDetailHooks from './paddleHubDetailHooks';

const PaddleHubDetail: React.FC = () => {
    const {
        modelDetail,
    } = usePaddleHubDetailHooks();

    return (
        <div className="page paddle-hub-detail-page">
            <Header />
            <Banner
                title="PaddleHub"
                subtitle="便捷地获取PaddlePaddle生态下的预训练模型，完成模型的管理和一键预测。配合使用Fine-tune API，可以基于大规模预训练模型快速完成迁移学习，让预训练模型能更好地服务于用户特定场景的应用"
            >
                <div className="paddle-hub-detail-page-banner-btn-group">
                    <span className="paddle-hub-detail-page-index">零基础快速开始<CaretRightOutlined /><CaretRightOutlined /><CaretRightOutlined /></span>
                    <a
                        href="https://github.com/PaddlePaddle/PaddleHub/blob/release/v2.1/docs/docs_ch/get_start/windows_quickstart.md"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button
                            type="primary"
                            size="large"
                            className="paddle-hub-detail-page-banner-btn"
                        >
                            Windows
                        </Button>
                    </a>
                    <a
                        href="https://github.com/PaddlePaddle/PaddleHub/blob/release/v2.1/docs/docs_ch/get_start/linux_quickstart.md"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button
                            type="primary"
                            size="large"
                            className="paddle-hub-detail-page-banner-btn"
                        >
                            Linux
                        </Button>
                    </a>
                    <a
                        href="https://github.com/PaddlePaddle/PaddleHub/blob/release/v2.1/docs/docs_ch/get_start/mac_quickstart.md"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button
                            type="primary"
                            size="large"
                            className="paddle-hub-detail-page-banner-btn"
                        >
                            Mac
                        </Button>
                    </a>
                </div>
            </Banner>

            <div className="paddle-hub-detail-page-container clear-both">
                <div className="paddle-hub-detail-page-container-right">
                    <Breadcrumb
                        className="paddle-hub-detail-page-container-breadcrumb"
                        separator={
                            <RightOutlined
                                className="paddle-hub-detail-page-container-breadcrumb-right"
                            />
                        }
                    >
                        <Breadcrumb.Item>
                            <a href="/hublist">
                                PaddleHub 首页
                            </a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <a
                                href={`/hubsearch?filter=en_category&value=${encodeURIComponent(JSON.stringify({ scenes: [modelDetail.typeName] }))}`}
                            >
                                {modelDetail.type}
                            </a>
                        </Breadcrumb.Item>
                        {
                            !!modelDetail.name
                            && <Breadcrumb.Item>
                                {modelDetail.name}
                            </Breadcrumb.Item>
                        }

                    </Breadcrumb>

                    <div className="paddle-hub-detail-page-container-h1">
                        {modelDetail.name}
                    </div>

                    <div className="paddle-hub-detail-page-container-info">
                        <div className="paddle-hub-detail-page-container-info-item">
                            类别
                            <span className="paddle-hub-detail-page-container-info-item-data">
                                {modelDetail.type}
                            </span>
                        </div>
                        <div className="paddle-hub-detail-page-container-info-item">
                            网络
                            <span className="paddle-hub-detail-page-container-info-item-data">
                                {modelDetail.network}
                            </span>
                        </div>
                        <div className="paddle-hub-detail-page-container-info-item">
                            数据集
                            <span className="paddle-hub-detail-page-container-info-item-data">
                                {modelDetail.dataset}
                            </span>
                        </div>
                    </div>

                    <div className="paddle-hub-detail-page-container-h2">
                        模型概述
                    </div>
                    <div className="paddle-hub-detail-page-container-summary">
                        {modelDetail.summary}
                    </div>
                    <div className="paddle-hub-detail-page-container-h2">
                        选择模型版本进行安装
                    </div>

                    <PaddleHubDetailVersion info={modelDetail.info} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PaddleHubDetail;
